// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Jr-z","inputDescription":"styles_inputDescription__37-xy"};